import { MintRegistrationComponent } from '../components/mintRegistration';

export const MintRegistration = () => {
    return <MintRegistrationComponent />;
};

export default MintRegistration;
